module.exports = __webpack_public_path__ + "img/icon4.0f371e36.png";